export default __webpack_public_path__ + "static/media/GIF-F3.de67ff77.gif";